<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bkht"><a class="page" id="pii"></a><a class="page" id="piii"></a>What a Philosopher Is</h1>
<h1 class="bk1">Becoming Nietzsche</h1>
<p class="bkau">Laurence Lampert</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">&amp;</span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lampert-0003.vue?42b89f18